import React from 'react'

import { publishEvent } from '@zet/analytics'
import { SH3, Stack, XStack, YStack } from '@zet/design-system'
import Pressable from '@zet/design-system/pressable'
import { i18n } from '@zet/localization'
import English from '@zet/svg/english'
import Hindi from '@zet/svg/hindi'

type ToggleLanguageType = {
  setToggleAccountType: (x: boolean) => void
  setIsDisabled: (x: boolean) => void
  isDisabled: boolean
  toggleAccountType: boolean
  eventName?: string
  eventPayload?: object
}

const ToggleLanguage = ({
  setToggleAccountType,
  setIsDisabled,
  isDisabled,
  toggleAccountType,
  eventName,
  eventPayload,
}: ToggleLanguageType) => {
  const styleActivated = (flag: boolean) =>
    `border rounded-xl ${flag ? 'border-primary-50' : 'border-grays-80'}  ${
      flag ? 'opacity-100' : 'opacity-30'
    }`

  const iconActivated = (flag: boolean) =>
    flag
      ? 'h-[36] w-[36] items-center rounded-[36]'
      : 'h-[36] w-[36] items-center rounded-[36]'

  return (
    <YStack>
      <XStack className="space-x-3">
        <Pressable
          onPress={() => {
            setToggleAccountType(false)
            setIsDisabled(false)
            publishEvent(eventName, {
              ...eventPayload,
              selected_language: 'English',
            })
          }}
          disabled={!isDisabled}
          className={styleActivated(!toggleAccountType)}
        >
          <XStack className="h-8 items-center space-x-3 py-2 pl-2 pr-3">
            <Stack className={iconActivated(!toggleAccountType)}>
              <English size={30} />
            </Stack>
            <SH3>{i18n.t('brandHelpAndSupport.english')}</SH3>
          </XStack>
        </Pressable>
        <Pressable
          onPress={() => {
            setToggleAccountType(true)
            setIsDisabled(true)
            publishEvent(eventName, {
              ...eventPayload,
              selected_language: 'Hindi',
            })
          }}
          disabled={isDisabled}
          className={styleActivated(toggleAccountType)}
        >
          <XStack className="h-8 items-center space-x-3 rounded-xl py-2 pl-2 pr-3">
            <Stack className={iconActivated(toggleAccountType)}>
              <Hindi size={36} />
            </Stack>
            <SH3 className="align-text-bottom">
              {i18n.t('brandHelpAndSupport.hindi')}
            </SH3>
          </XStack>
        </Pressable>
      </XStack>
    </YStack>
  )
}

export default ToggleLanguage
